import { GridColDef, GridValidRowModel } from '@mui/x-data-grid/models';
import { GridConfig } from '@/common/components/app-data-grid/GridConfig.ts';

export function modelColumnDefFactory<TModel extends GridValidRowModel>(
  gridConfig?: GridConfig<TModel>
) {
  return (
    key: keyof TModel & string,
    definition: Omit<GridColDef<TModel>, 'sortable' | 'filterable' | 'field'>
  ): GridColDef<TModel> => {
    const sortable = gridConfig?.sortableFields?.includes(key) ?? false;
    const filterable = gridConfig?.filterableFields?.includes(key) ?? false;
    return {
      ...definition,
      field: key,
      sortable,
      filterable,
      disableColumnMenu: definition.disableColumnMenu ?? (!sortable && !filterable),
      minWidth: definition.minWidth ?? 100,
    };
  };
}
